import {storyblokEditable, useStoryblokApi} from "@storyblok/react";
import {transformImage} from "../../utils/StoryblokService";
import classNames from "classnames";
import Image from "next/image";
import {IFeatureItem} from "../../types/IFeatureItem";
import React from "react";
import {richTextResolver} from "@storyblok/richtext";

export default function Incentive3Column({blok}: { blok: any }) {
    const waveStyles = {
        'transform': 'scale(2, 2.5) translate(127px, -196px)'
    }

    const { render } = richTextResolver()


    return (
        <div className="bg-warm-gray-50 relative overflow-hidden  " {...storyblokEditable(blok)}>
            <div className={'w-[50vw] h-full absolute z-10 top-0 left-0 pointer-events-none'} style={waveStyles}>
                {/*<img src={'/images/waves.png'} className={'w-full h-full rotate-180 opacity-[95%]'}/>*/}
            </div>

            <div className="mx-auto max-w-7xl py-12 sm:px-2 padding-normal lg:px-4 relative z-10">
                <div className="mx-auto max-w-2xl px-4 lg:max-w-none">
                    <div className="grid grid-cols-1 items-center gap-y-10 gap-x-16 lg:grid-cols-2">
                        <div>
                            <h2 className="text-4xl font-bold tracking-tight text-gray-900">
                                {blok.title}
                            </h2>
                            <div
                                className="mt-4 text-gray-700 rich-text"
                                dangerouslySetInnerHTML={{
                                    __html: render(blok.subtitle) as string
                                }}
                            />

                        </div>
                        <div className="aspect-w-3 aspect-h-2 overflow-hidden rounded-lg bg-warm-gray-100">
                            <Image
                                src={transformImage(blok.image.filename, blok.imagesize)}
                                className={classNames({"object-cover object-center": true})}
                                alt={blok.image?.alt}
                                width={800}
                                height={600}
                            />
                        </div>
                    </div>
                    <div className="mt-16 grid grid-cols-1 gap-y-10 gap-x-8 lg:grid-cols-3">
                        {blok.items.map((item: IFeatureItem, index: number) => (
                            <div key={item.title} className="sm:flex lg:block shadow bg-white rounded-lg p-4"
                                 data-aos={'fade-in'}
                                 data-aos-delay={index * 250}
                            >
                                <div className="sm:flex-shrink-0">
                                    <div className={'bg-amber-300 p-1 rounded-md inline-block'}>
                                        <div
                                            className={'w-full text-white'}
                                            dangerouslySetInnerHTML={{
                                                __html: (item.icon)
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="mt-4 sm:mt-0 sm:ml-6 lg:mt-6 lg:ml-0">
                                    <h3 className="text-sm font-medium text-gray-900">{item.title}</h3>
                                    <div
                                        className="mt-4 text-gray-700 rich-text"
                                        dangerouslySetInnerHTML={{
                                            __html: render(item.subtitle) as string
                                        }}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
